/**
 * src/services/config.ts
 * Centralized backend configuration. CRA injects REACT_APP_API_URL from
 * .env.development (start) or .env.production (build).
 */

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const BASE_URL = `${API_URL}/api`;

export const imageUrl = (url?: string): string => {
  if (!url) return '';
  return url.startsWith('data:') || url.startsWith('http') ? url : `${API_URL}${url}`;
};
